<template>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('Companies')}}</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <router-link class="btn btn-light float-right" style="color:white;text-decoration: none;" to="/companies/new"><span>{{$t("Add New Company")}}</span></router-link>
            </b-col>

          </b-row>
          <!-- Main table element -->

          <b-table
            ref="table"
            show-empty
            hover
            small
            responsive
            :items="$store.state.companies"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :sort-compare="customCompare"
            @filtered="onFiltered"
          >
            <template v-slot:cell(name)="row">
              <b-link class="nav-link" :to="'/companies/'+row.item.id">{{ row.item.name }} </b-link>
            </template>
            <template v-slot:cell(admin)="row">
              <b-link class="nav-link" :to="'/users/'+row.item.admin"> {{ row.item.adminName }} </b-link>
            </template>

            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="outline-primary" size="sm" @click="getCompanyModal(row.item.id)" class="mr-1">
                {{$t('Edit')}}
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
        <b-modal
          id="modal-edit-company"
          ref="modal"
          title="Edit Company"
          @show="resetModal"
          @hidden="resetModal"
          @ok="saveCompany"
          okVariant="light"
          ok-title-html="<span style='color:white;'>Submit</span>"
          header-bg-variant="light"
          header-text-variant="white"
        >
          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group
              label="Name"
              label-for="name-input"
            >
              <b-form-input
                id="name-input"
                type="text"
                v-model="companyForm.name"
                :state="$v.companyForm.name.$dirty ? !$v.companyForm.name.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group  id="input-group-4" label="Administrator:" label-for="input-4">
              <b-form-select
                id="input-4"
                size="sm"
                v-model="companyForm.admin"
                :options="activeUsers"
                :state="$v.companyForm.admin.$dirty ? !$v.companyForm.admin.$error : null"
              ></b-form-select>
              <b-form-invalid-feedback id="input-7-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group id="input-group-2" label="VAT Number:" label-for="input-23">
              <b-form-input
                id="input-23"
                v-model="companyForm.vat"
                placeholder="VAT Number"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group style="width: 50%;float:left;" id="input-group-2" label="Telephone:" label-for="input-5" >
              <b-form-input
                type="tel"
                id="input-5"
                v-model="companyForm.phoneNumber"
                placeholder="Telephone"
              ></b-form-input>
              <b-form-invalid-feedback id="input-6-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group style="width: 50%;float:left;padding-left: 5px" label="2nd Telephone:" label-for="input-5" >
              <b-form-input
                type="tel"
                id="input-5"
                v-model="companyForm.secondPhoneNumber"
                placeholder="Telephone"
              ></b-form-input>
              <b-form-invalid-feedback id="input-6-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group  style="width: 50%;float:left;" label="Address:" label-for="input-23">
              <b-form-input
                id="input-23"
                v-model="companyForm.address"
                placeholder="Address"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group style="width: 50%;float:left;padding-left: 5px"  label="Postcode:" label-for="input-23">
              <b-form-input
                id="input-23"
                v-model="companyForm.postcode"
                placeholder="Address"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group  id="input-group-4" label="Status:" label-for="input-4">
              <b-form-select
                id="input-4"
                size="sm"
                v-model="companyForm.status"
                :options="statuses"
                :state="$v.companyForm.status.$dirty ? !$v.companyForm.status.$error : null"
              ></b-form-select>
              <b-form-invalid-feedback id="input-7-live-feedback">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
      </div>
    </div>

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
export default {
  data () {
    return {
      loading: false,
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}, {text: this.$t('Expired'), value: 'Expired'}],
      companyForm: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      activeUsers: [{text: this.$t('Select Admin'), value: ''}]
    }
  },
  validations: {
    companyForm: {
      admin: {
        required
      },
      name: {
        required
      },
      status: {
        required
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    fields () {
      return [
        {key: 'name', label: this.$t('name'), sortable: true, sortDirection: 'desc', class: 'text-left'},
        {key: 'admin', label: this.$t('Administrator'), sortable: true, class: 'text-center'},
        {key: 'status', label: this.$t('Status'), sortable: true, class: 'text-center'},
        {key: 'createdAt', label: this.$t('Created  At'), sortable: true, class: 'text-center'},
        {key: 'actions', label: this.$t('Actions'), class: 'text-center'}
      ]
    }
  },
  mounted () {
    // Set the initial number of items
    this.totalRows = this.$store.state.companies.length
    if (this.$store.state.companies.length === 0) {
      this.$store.dispatch('fetchCompanies')
    }
    // this.mapUsers()
    console.log(this.$store.state.users)
  },
  methods: {
    customCompare (a, b, key) {
      if (['date', 'time', 'dateIn', 'dateOut', 'createdAt', 'createdAtFormatted', 'updatedAtFormatted'].includes(key)) {
        var aDate = moment(a[key], 'DD/MM/YYYY kk:mm')
        var bDate = moment(b[key], 'DD/MM/YYYY kk:mm')
        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1
          } else if (aDate > bDate) {
            return 1
          } else {
            return 0
          }
        }
        return null
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    },
    info (item, index, button) {
      this.$router.push('/companies/' + item.id)
    },
    fetchActiveUsers (id) {
      // setting selected license
      var self = this
      this.$firebase.firestore().collection('users').where('status', '==', 'Active').where('companyId', '==', id).get().then(function (users) {
        self.activeUsers = [{text: self.$t('Select Admin'), value: ''}]
        users.forEach(function (user) {
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName
          self.activeUsers.push({value: user.id, text: name})
        })
      })
    },
    getCompanyModal (id) {
      this.$bvModal.show('modal-edit-company')
      this.companyForm = JSON.parse(JSON.stringify(this.$store.state.companies.find(x => x.id === id)))
      this.fetchActiveUsers(id)
      console.log('company form=======', this.companyForm)
    },
    saveCompany (e) {
      e.preventDefault()

      this.$v.companyForm.$touch()
      if (this.$v.companyForm.$anyError) {
        return
      }
      this.loading = true
      let self = this
      const updateCompany = this.$firebase.functions().httpsCallable('updateCompany')
      updateCompany(
        {
          id: self.companyForm.id,
          name: self.companyForm.name,
          address: self.companyForm.address,
          postcode: self.companyForm.postcode,
          vat: self.companyForm.vat,
          phoneNumber: self.companyForm.phoneNumber,
          secondPhoneNumber: self.companyForm.secondPhoneNumber,
          status: self.companyForm.status,
          admin: self.companyForm.admin
        }
      ).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Company Updated!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.$store.dispatch('fetchCompanies')
            self.$refs.table.refresh()
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    mapUsers () {
      // var self = this;
      // this.$store.state.users.forEach(function (user) {
      //
      //   self.users =
      // })
    },
    resetModal () {
      this.$v.$reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Companies.vue